import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    // 标签页相关状态
    visitedViews: [], // 已访问的标签页
    cachedViews: [] // 需要缓存的组件名称
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    // 添加标签页
    ADD_VISITED_VIEW: (state, view) => {
      // 如果标签页已经存在，则不添加
      if (state.visitedViews.some(v => v.path === view.path)) return
      // 限制标签页数量，最多不超过10个
      if (state.visitedViews.length >= 10) {
        state.visitedViews.shift() // 移除第一个标签页
      }
      // 添加新的标签页
      state.visitedViews.push({
        name: view.name,
        path: view.path,
        query: view.query,
        params: view.params,
        meta: view.meta || {}
      })
    },
    // 添加缓存组件
    ADD_CACHED_VIEW: (state, view) => {
      // 如果组件名称不存在，则添加到缓存列表
      if (state.cachedViews.includes(view.name)) return
      state.cachedViews.push(view.name)
    },
    // 删除标签页
    DEL_VISITED_VIEW: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1) // 从已访问列表中删除
          break
        }
      }
    },
    // 删除缓存组件
    DEL_CACHED_VIEW: (state, view) => {
      const index = state.cachedViews.indexOf(view.name)
      if (index > -1) {
        state.cachedViews.splice(index, 1) // 从缓存列表中删除
      }
    },
    // 删除其他标签页
    DEL_OTHERS_VISITED_VIEWS: (state, view) => {
      state.visitedViews = state.visitedViews.filter(v => {
        return v.meta.affix || v.path === view.path // 保留固定标签页和当前标签页
      })
    },
    // 删除其他缓存组件
    DEL_OTHERS_CACHED_VIEWS: (state, view) => {
      const index = state.cachedViews.indexOf(view.name)
      if (index > -1) {
        state.cachedViews = state.cachedViews.slice(index, index + 1) // 只保留当前组件的缓存
      } else {
        state.cachedViews = [] // 如果没有找到，则清空缓存
      }
    },
    // 删除所有标签页
    DEL_ALL_VISITED_VIEWS: (state) => {
      // 保留固定标签页
      const affixedViews = state.visitedViews.filter(v => v.meta.affix)
      state.visitedViews = affixedViews
    },
    // 删除所有缓存组件
    DEL_ALL_CACHED_VIEWS: (state) => {
      state.cachedViews = [] // 清空所有缓存
    },
    // 更新标签页
    UPDATE_VISITED_VIEW: (state, view) => {
      for (let v of state.visitedViews) {
        if (v.path === view.path) {
          v.meta = view.meta || {} // 更新标签页的元信息
          v.query = view.query
          v.params = view.params
          break
        }
      }
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    // 添加访问过的标签页
    addVisitedView({ commit }, view) {
      commit('ADD_VISITED_VIEW', view)
    },
    // 添加需要缓存的组件
    addCachedView({ commit }, view) {
      commit('ADD_CACHED_VIEW', view)
    },
    // 删除访问过的标签页
    delVisitedView({ commit }, view) {
      commit('DEL_VISITED_VIEW', view)
    },
    // 删除需要缓存的组件
    delCachedView({ commit }, view) {
      commit('DEL_CACHED_VIEW', view)
    },
    // 删除其他访问过的标签页
    delOthersVisitedViews({ commit }, view) {
      commit('DEL_OTHERS_VISITED_VIEWS', view)
    },
    // 删除其他需要缓存的组件
    delOthersCachedViews({ commit }, view) {
      commit('DEL_OTHERS_CACHED_VIEWS', view)
    },
    // 删除所有访问过的标签页
    delAllVisitedViews({ commit }) {
      commit('DEL_ALL_VISITED_VIEWS')
    },
    // 删除所有需要缓存的组件
    delAllCachedViews({ commit }) {
      commit('DEL_ALL_CACHED_VIEWS')
    },
    // 更新访问过的标签页
    updateVisitedView({ commit }, view) {
      commit('UPDATE_VISITED_VIEW', view)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js